import { connect } from 'react-redux';

import CreatePanel from './';

const mapStateToProps = state => {
  const length = state.routerLocations.length;
  const prevPath = length > 1 ? state.routerLocations.slice(-2)[0] : '/';
  return {
    isIframe : state.identity.isWebappUser,
    previousRoute: prevPath ? prevPath : '/'
  }
};

export default connect(mapStateToProps)(CreatePanel);
